import React from 'react'

import {Link} from 'react-router-dom'

import {ReactComponent as Mail} from '../assets/icons/mail.svg'
import {ReactComponent as Phone} from '../assets/icons/phone.svg'
import {ReactComponent as Fax} from '../assets/icons/fax.svg'

import { useLanguage, useTranslate } from '../Context/LanguageContext'

import Logo from '../Util/Logo'

import "./Footer.css"
import ReplaiWidget from '../Util/ReplaiWidget'

const Footer = () => {
    const t = useTranslate("footer")
    const {ForRegular, ForChina} = useLanguage()

    return ( 
        <footer>
            <ForRegular>
                <ReplaiWidget customerId='139be334-7f71-43b5-a553-d4e693c69953' />
            </ForRegular>

            <div className='me'>
                <ForRegular>
                    <> 
                    <Logo/>
                    <p className='consulting'>China <br/> Consulting</p>
                    </> 
                </ForRegular>
                
                <ForChina>
                    <>
                    <Logo/>
                        <p className='consulting'>中国 <br/> 咨询</p>
                    </>     
                </ForChina>
                
            </div>

            <ForRegular>
                <div className='links'>
                    <h3>{t("links")} </h3>
                    <Link to="/">       Home                </Link>
                    <Link to="/invest">        {t("invest")}       </Link>
                    <Link to="/purchase">       {t("purchase")}     </Link>
                    <Link to="/distribution">      {t("distribution")} </Link>
                    <Link to="/recruitment">   {t("professionals")}</Link>
                    <Link to="/about">         {t("about")}        </Link>
                </div>
            </ForRegular>
                
            <ForChina>
                <div className='links'>
                    <h3>{t("links")} </h3>
                    <Link to="/">首页</Link>
                    <Link to="/visa-consulting">德国签证与移民</Link>
                    <Link to="/business">德国商务与投资</Link>
                    <Link to="/international-trade">中欧国际贸易</Link>
                </div>
            </ForChina>


            <div className='address'>
                <h3>{t("address")}</h3>
                <p>SINIS GmbH</p>
                <p>Waldstr. 14</p>
                <p>D-85635 Höhenkirchen</p>
                <p>{t("germany")}</p>
            </div>

            <div className='contact'>
                <h3>{t("contact")}</h3>
                
                <div className='line'>
                    <Mail/>
                    <a href='mailto:info@sinis.de'>info@sinis.de</a>
                </div>

                <div className='line'>
                    <Phone/>
                    <a href='tel:+4981028961688'>(+49) 8102 89616-88</a>
                </div>

                <div className='line'>
                    <Fax/>
                    <a href='fax:+4981028961699'>(+49) 8102 89616-99</a>
                </div>
            </div>

            <div className='legal'>
                <p className='copyright'>© 2026 Sinis GmbH</p>

                <div>
                    <Link to="/imprint">{t("imprint")}</Link>
                    <Link to="/privacy-policy">{t("privacy-policy")}</Link>
                </div>
            </div>


        </footer> 
    );
}
 
export default Footer;